import i18next from 'i18next'
import React from 'react'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { CourseSearchLayout } from './courseSearchLayout'
import { courseSearchPageStateUpdaters, CourseSearchResult, CourseSearchState } from './courseSearchState'

export const courseSearchWidget = (
  state: CourseSearchState
): Widget<Updater<CourseSearchState>> =>
  any([
    async<CourseSearchResult>(state.result).map(
      courseSearchPageStateUpdaters.updateSearchResult
    ),
    fromJSX(() => (
      <CourseSearchLayout {...state} />
    ))
  ])